import {
  APP_ACCESS_KEYS,
  APP_ACCESS_LABELS,
  finalizeAppAccess,
  type AppAccessMap,
} from "@/lib/appAccess";

const BI_KEYS = APP_ACCESS_KEYS.filter(
  (k) =>
    !k.startsWith("solicitacaoPagamento") &&
    !k.startsWith("chaoDeObra") &&
    k !== "locacoes" &&
    k !== "tarefas" &&
    k !== "folhaPagamentos" &&
    k !== "genteGestao" &&
    k !== "manutencao",
);

const CHAO_DE_OBRA_KEYS = APP_ACCESS_KEYS.filter((k) => k.startsWith("chaoDeObra"));

const SOL_PAG_KEYS = APP_ACCESS_KEYS.filter((k) => k.startsWith("solicitacaoPagamento"));

const OPERACIONAIS_KEYS = APP_ACCESS_KEYS.filter(
  (k) =>
    k === "locacoes" ||
    k === "tarefas" ||
    k === "manutencao" ||
    k === "folhaPagamentos" ||
    k === "genteGestao",
);

export function AccessCheckGrid({
  value,
  onChange,
  idPrefix,
}: {
  value: AppAccessMap;
  onChange: (next: AppAccessMap) => void;
  idPrefix: string;
}) {
  const renderCheck = (key: typeof APP_ACCESS_KEYS[number]) => (
    <label key={key} className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer">
      <input
        id={`${idPrefix}-${key}`}
        type="checkbox"
        className="mt-0.5 rounded border-slate-300 text-brand-600 focus:ring-brand-500"
        checked={value[key] === true}
        onChange={(e) => {
          const checked = e.target.checked;
          const next = { ...value, [key]: checked };
          if (key === "chaoDeObra" && !checked) {
            next.chaoDeObraAprovar = false;
          }
          onChange(finalizeAppAccess(next));
        }}
      />
      <span>{APP_ACCESS_LABELS[key]}</span>
    </label>
  );

  return (
    <div className="space-y-4">
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Módulos do BI</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {BI_KEYS.map(renderCheck)}
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Chão de Obra</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {CHAO_DE_OBRA_KEYS.map(renderCheck)}
        </div>
        <p className="text-xs text-slate-400 mt-2">
          O módulo libera o registro de medições. A aprovação é opcional: marque só se este grupo puder
          avaliar, aprovar ou devolver um registro. Administradores já aprovam. Marcar a aprovação inclui
          o módulo automaticamente.
        </p>
      </div>
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Solicitação de pagamento</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {SOL_PAG_KEYS.map(renderCheck)}
        </div>
        <p className="text-xs text-slate-400 mt-2">
          Aprovação operacional ou financeira inclui automaticamente o acesso base ao módulo.
        </p>
      </div>
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Operacionais</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {OPERACIONAIS_KEYS.map(renderCheck)}
        </div>
      </div>
    </div>
  );
}
